import { boxShadow, color, spacing } from '@upstox/upstox-ui';

export const base: CSSFunction<{
  transitionState?: TransitionState;
  fullScreen?: boolean;
}> = ({ cssProps, theme }) => {
  const { transitionState = 'mounted', fullScreen = false } = cssProps;
  const isMounted = transitionState === 'mounted';
  return {
    zIndex: 1, // default for overlay is 1, it should be the same to be in front of
    backgroundColor: color(theme, theme.modals.background),
    borderRadius: spacing(theme, theme.modals.borderRadius),
    boxShadow: boxShadow(theme, theme.modals.boxShadow),
    margin: 'auto',
    maxHeight: '100%',
    width: fullScreen ? theme.modals.fullScreenWidth : theme.modals.width,
    opacity: isMounted ? 1 : 0,
    overflow: 'hidden',
    position: 'relative',
    transform: isMounted ? 'none' : 'translateY(10%) scale3D(0.9, 0.9, 1)',
    transition: 'all 0.2s ease',

    '& input': {
      fontFamily: theme.fonts.tvFont,
    },
  };
};

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  width: '15px',
  height: '15px',
  color: color(theme, theme.colors.icon1),
});

export const footer: CSSFunction = ({ theme }) => ({
  padding: '15px',

  '& button': {
    fontFamily: theme.fonts.tvFont,
  },
});
